import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnumTipoCadastroVinculo, EnumtoArray } from 'app/shared/enum.service';
import { GrupoUsuariosService } from 'app/main/a2w/supervisor/restricoes-permissoes/grupo-usuarios/grupo-usuarios.service';
import { RegrasLimiteDespesaViagemDTO } from '../models/regras-limite-despesa-viagem.model';
import { TiposDespesasService } from '../../tipos-despesas/services/tipos-despesas.service';
import { TiposPagamentosService } from '../../tipos-pagamentos/services/tipos-pagamentos.service';
import { MatSnackBarConfigComponent } from "app/shared/matSnackBarConfig/matSnackBarConfig.component";
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { empty } from 'rxjs';
import { VinculoDespesaViagem } from '../models/vinculo-agrupado.interface';
@Component({
    selector: 'app-add-vinculo-form',
    templateUrl: './add-vinculo-form.component.html',
    styleUrls: ['./add-vinculo-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AddVinculoFormComponent {

    vinculoForm: UntypedFormGroup;
    action: string;
    dialogTitle: string;
    
    enumTipoCadastroVinculo: any[] = [];
    tiposDespesas: any[] = [];
    tiposPagamentos: any[] = [];
    gruposUsuarios: any[] = [];
    usuarios: any[] = []
    listaRegrasLimiteDespesaViagem: RegrasLimiteDespesaViagemDTO[] = [];
    matSnackBarConf: any;

    isloadingTipoDespesa: boolean = false;
    filteredTipoDespesa: any = [];

    isloadingTipoPagamento: boolean = false;
    filteredTipoPagamento: any = [];

    constructor(
        public matDialogRef: MatDialogRef<AddVinculoFormComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: { action: string, tipoVinculosUtilizados: number[], limiteDiario: boolean, listReferencias?: VinculoDespesaViagem[], tipoVinculo?: EnumTipoCadastroVinculo },
        private _formBuilder: UntypedFormBuilder,
        private _gruposService: GrupoUsuariosService,
        private _tipoPagamentosService: TiposPagamentosService,
        private _tipoDespesasService: TiposDespesasService,
    ) {

        this.action = this._data.action;
        
        this.dialogTitle = 'Adicionar Vínculo';

        this.loadTipoCadastroVinculo();
        this.loadGruposUsuarios();
        
        this.matSnackBarConf = new MatSnackBarConfigComponent()
        
        this.vinculoForm = this.createVinculoGroup();

        this.vinculoForm.get('tipoVinculo').valueChanges.subscribe(res => {
            this._data.listReferencias = [];
            if (!this._data.limiteDiario) {
                switch (res) {
                    case 0:
                        this.vinculoForm.get('tipoDespesaAux').setValidators(Validators.required);
                        this.vinculoForm.get('tipoDespesaAux').updateValueAndValidity();

                        this.vinculoForm.get('tipoPagamentoAux').clearValidators();
                        this.vinculoForm.get('tipoPagamentoAux').updateValueAndValidity();
                        this.vinculoForm.get('tipoPagamentoAux').setValue("");

                        this.vinculoForm.get('grupoAux').clearValidators();
                        this.vinculoForm.get('grupoAux').updateValueAndValidity();
                        this.vinculoForm.get('grupoAux').setValue("");
                        break;
                    case 1:
                        this.vinculoForm.get('tipoPagamentoAux').setValidators(Validators.required);
                        this.vinculoForm.get('tipoPagamentoAux').updateValueAndValidity();

                        this.vinculoForm.get('tipoDespesaAux').clearValidators();
                        this.vinculoForm.get('tipoDespesaAux').updateValueAndValidity();
                        this.vinculoForm.get('tipoDespesaAux').setValue("");

                        this.vinculoForm.get('grupoAux').clearValidators();
                        this.vinculoForm.get('grupoAux').updateValueAndValidity();
                        this.vinculoForm.get('grupoAux').setValue("");
                        break;
                    case 2:
                        this.vinculoForm.get('grupoAux').setValidators(Validators.required);
                        this.vinculoForm.get('grupoAux').updateValueAndValidity();

                        this.vinculoForm.get('tipoDespesaAux').clearValidators();
                        this.vinculoForm.get('tipoDespesaAux').updateValueAndValidity();
                        this.vinculoForm.get('tipoDespesaAux').setValue("");

                        this.vinculoForm.get('tipoPagamentoAux').clearValidators();
                        this.vinculoForm.get('tipoPagamentoAux').updateValueAndValidity();
                        this.vinculoForm.get('tipoPagamentoAux').setValue("");
                        break;
                }
            }
            
        });

        this.vinculoForm.get('tipoDespesaAux').valueChanges
		    .pipe(
			debounceTime(300),
			tap(() => this.isloadingTipoDespesa = true),
			switchMap(value => (value != '' && value != null && value.length >= 3 ? this._tipoDespesasService.search(value) : empty())
				.pipe(
					finalize(() => this.isloadingTipoDespesa = false),
				)
			)
		).subscribe(despesa => {
			this.filteredTipoDespesa = despesa.tipoDespesaViagem;
		});

        this.vinculoForm.get('tipoDespesaAux').valueChanges.subscribe(res => {
            if(res?.id && this._data.limiteDiario){
                if(!this._data.listReferencias.some(x => parseFloat(x.tipoVinculoReferenciaId) === res.id)){
                    this._data.listReferencias.push({
                        id: 0,
                        tipoVinculoReferenciaId: res.id,
                        tipoVinculo: 0,
                        descricao: res.descricaoCadastro
                    });
                    this.vinculoForm.get('tipoDespesaAux').setValue(null);
                    this.filteredTipoDespesa = [];
                }
            }

        })

        this.vinculoForm.get('tipoPagamentoAux').valueChanges
		    .pipe(
			debounceTime(300),
			tap(() => this.isloadingTipoPagamento = true),
			switchMap(value => (value != '' && value != null && value.length >= 3 ? this._tipoPagamentosService.search(value) : empty())
				.pipe(
					finalize(() => this.isloadingTipoPagamento = false),
				)
			)
		).subscribe(pagamento => {
			this.filteredTipoPagamento = pagamento.tipoPagtoDespesaViagem;
		});

        this.vinculoForm.get('tipoPagamentoAux').valueChanges.subscribe(res => {
            if(res?.id && this._data.limiteDiario){
                if(!this._data.listReferencias.some(x => parseFloat(x.tipoVinculoReferenciaId) === res.id)){
                    this._data.listReferencias.push({
                        id: 0,
                        tipoVinculoReferenciaId: res.id,
                        tipoVinculo: 1,
                        descricao: res.descricaoCadastro
                    });
                    this.vinculoForm.get('tipoPagamentoAux').setValue(null);
                    this.filteredTipoPagamento = [];
                }
            }

        });

        this.vinculoForm.get('grupoAux').valueChanges.subscribe(res => {
            if(res?.userGroupId && this._data.limiteDiario){
                if(!this._data.listReferencias.some(x => x.tipoVinculoReferenciaId === res.userGroupId)){
                    this._data.listReferencias.push({
                        id: 0,
                        tipoVinculoReferenciaId: res.userGroupId,
                        tipoVinculo: 2,
                        descricao: res.userGroupName
                    });
                    this.vinculoForm.get('grupoAux').setValue(null);
                }
            }

        });

    }

    createVinculoGroup(): UntypedFormGroup {
        return this._formBuilder.group({

            tipoVinculo: [this._data.tipoVinculo ?? ''],

            tipoDespesaAux: '',
            tipoPagamentoAux: '',
            grupoAux: ''

        });
    }

    
    adicionar() {
        
        const data = this.vinculoForm.getRawValue();
        if(!this._data.limiteDiario) {
            switch(data.tipoVinculo){
                case 0:
                    this._data.listReferencias = [{
                        id:this._data.listReferencias[0]?.id ?? 0,
                        tipoVinculo: 0,
                        tipoVinculoReferenciaId: data.tipoDespesaAux.id,
                    }]
                break;
                case 1: 
                    this._data.listReferencias = [{
                        id:this._data.listReferencias[0]?.id ?? 0,
                        tipoVinculo: 1,
                        tipoVinculoReferenciaId: data.tipoPagamentoAux.id,
                    }]
                break;
                case 2:
                    this._data.listReferencias = [{
                        id:this._data.listReferencias[0]?.id ?? 0,
                        tipoVinculo: 2,
                        tipoVinculoReferenciaId: data.grupoAux.userGroupId,
                    }]                    
                break;    
            }
        }

        this.matDialogRef.close([this.action, this._data.listReferencias]);
    }


    displayTipo(item: any) {
        if (item) {
            return item.descricaoCadastro;
        }
    }

    loadTipoCadastroVinculo() {

        this.enumTipoCadastroVinculo = EnumtoArray(EnumTipoCadastroVinculo);

    }

    loadGruposUsuarios() {
        this._gruposService.listAll().then(result => {
            this.gruposUsuarios = result;
        });
    }

    desabilitaTipoVinculo(idTipoVinculo: number) {        
        return this._data.tipoVinculosUtilizados.some(tipoVinculo => tipoVinculo == idTipoVinculo);
    }

    removeVinculo(item: any) {
        const index = this._data.listReferencias.indexOf(item);
        if (index >= 0) {
            this._data.listReferencias.splice(index, 1);
        }
    }
}
